export default __webpack_public_path__ + "static/media/1980.00b2e490.png";